import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { Process } from '../shared';
import { State } from '../store/reducers';
import { Store, select } from '@ngrx/store';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Subscription, Observable } from 'rxjs';
import { Category } from '../shared/category/category.model';
import * as fromUserInfo from '../user-info/store';

@Component({
    selector: 'ef-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    standalone: false
})
export class MainMenuComponent implements OnInit {
  public items$: Observable<Array<Process>>;
  // @Input() public userProccessCategories: Category[];
  private subscription: Subscription;
  private active = true;

  constructor(
    private store: Store<State>,
    @Inject(LoggingService) private log: LoggingService,
  ) {
  }

  ngOnInit() {
    this.items$ = this.store.pipe(
      select(fromUserInfo.getUserProcessesMain)
    );
  }
}
